/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('revenuePlanningFlights',{
                parent: 'app',
                url: '/revenuePlanning/flightsItinerary/:id',
                params: {
                    makerId_modelId: "",
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenuePlanning/revenuePlanningFlight/revenuePlannings.html',
                        controller: 'revenuePlanningCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['revenuePlanning']);
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('itineraryListRevenue')
                            }],
                            'modelAircrafts': ['modelAircraftService', function(modelAircraftService){
                                return modelAircraftService.getModelAircrafts()
                            }],
                            categories: ['tariffClassService',function(tariffClassService){
                                return tariffClassService.getFareClassesFare();
                            }],
                            routesItineraries: ['revenuePlanningService','$stateParams', function (revenuePlanningService,$stateParams) {
                                return revenuePlanningService.getRouteItinerariesRevenuePlan($stateParams.id, $stateParams.makerId_modelId,$stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
    }
})();


